import { formatDate } from "src/Common/common";
import BlueButton from "src/Components/Common/bluebutton";
import { useState } from "react";

const Notes = ({ notes, sendNote }) => {
  const [message, setMessage] = useState("");

  const send = () => {
    message.trim() !== "" && sendNote(message);
    setMessage("");
  };

  return (
    <div className="w-full">
      {notes.map((note, index) => (
        <div key={index} className="w-full flex items-center gap-3 mb-3">
          <span className="font-family-OpenSansRegular text-[12px] text-titleColor min-w-[140px]">
            {formatDate(note.createdAt)}
          </span>
          <span className="font-family-OpenSansRegular text-[12px] text-titleColor flex-auto">{note.message}</span>
          <span className="font-family-OpenSansRegular text-[12px] text-titleColor min-w-[150px]">
            {note.sender ? note.sender.name : note.customerSender ? note.customerSender.name : ""}
          </span>
        </div>
      ))}

      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Write message"
        rows={3}
        className="w-full border-solid border-[1px] border-borderColor rounded-[5px] py-2 px-3 font-family-OpenSansRegular text-[12px] text-titleColor"
      />
      <div className="w-full flex items-center justify-end">
        <BlueButton title="SEND" onClicked={send} />
      </div>
    </div>
  );
};

export default Notes;
